@if (menuitems && menuitems.length > 0) {
  <div class="context-menu" [ngClass]="{'active': menuIsOpen}">
    @if (visibleMenuButton) {
      <button mat-icon-button aria-hidden="false" [matMenuTriggerFor]="menu">
        <mat-icon fontSet="fa" fontIcon="fa-ellipsis-h" />
      </button>
      <mat-menu #menu="matMenu">
        <ng-container *ngTemplateOutlet="menuItems" />
      </mat-menu>
    }
    @if (!visibleMenuButton) {
      <ng-container *ngTemplateOutlet="menuItems" />
    }
  </div>
}
<ng-template #menuItems><ng-content select="menuitem" /></ng-template>
